import axiosIns from '@/plugins/axios'

export default {
  checkin(token) {
    return axiosIns.post('/waiter/checkins', { token })
  },

  getCheckinQr(customerId) {
    return axiosIns.get(`/waiter/customers/${customerId}/checkin_qr`)
  },
}
